import OrgNotificationSettingsPanel from '../components/OrgNotificationSettings'

export default function NotificationsSettings() {
  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="text-display-md" style={{ margin: 0 }}>Notifications</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--text-muted)', fontSize: '13px' }}>
            Configure delivery channels for RCA, patch, and PR-ready alerts.
          </p>
        </div>
      </div>

      <OrgNotificationSettingsPanel />
    </div>
  )
}
